import Notification from '@service-victoria/component-library/components/Notification/Info';
import Text from '@service-victoria/component-library/components/Text';
import colors from '@service-victoria/component-library/utils/colors';
import device from '@service-victoria/component-library/utils/device';
import styled from 'styled-components';

export const Wrapper = styled.div``;

export const HeadingWrapper = styled(Wrapper)`
  margin-bottom: 32px;
`;

export const Spacer4 = styled(Wrapper)`
  margin-bottom: 4px;
`;

export const Spacer10 = styled(Wrapper)`
  margin-bottom: 10px;
`;

export const Spacer16 = styled(Wrapper)`
  margin-bottom: 16px;
`;

export const Spacer24 = styled(Wrapper)`
  margin-bottom: 24px;
`;

export const Spacer48 = styled(Wrapper)`
  margin-bottom: 48px;
`;

export const ContentWrapper = styled(Wrapper)`
  margin-bottom: 48px;
`;

export const ListWrapper = styled.div`
  color: ${colors.blueGrey};
  ul {
    margin: 0;
  }
`;

export const InfoNotification = styled(Notification)`
  ${Text.Body} {
    margin: 0;
  }

  max-width: 350px;
  @media ${device.isMobile} {
    max-width: none;
  }
`;

export const HorizontalRule = styled.hr`
  border: 1px solid ${colors.blueGrey10};
  color: ${colors.blueGrey10};
  margin: 20px 0 20px;
`;
